import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
// Queues overlapping calls to a render function instead of letting them race
// to remove-then-append the DOM element, which can leave duplicate elements or
// drop a caller's initialQuestion (SDK2's only message-delivery mechanism).
// Not keyed by containerId — relies on callers only ever mounting one agent
// surface per containerId at a time.
export function serializeRenderCalls(render) {
  var inFlight = Promise.resolve();
  return function runSerialized() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var next = inFlight.catch(function () {
      return undefined;
    }).then(function () {
      return render.apply(void 0, args);
    });
    inFlight = next;
    return next;
  };
}